// services/api.ts

import axios from 'axios';

// API ana URL ve headers
const api = axios.create({
  baseURL: 'https://app-ghr-lighting-controls-backend-prod.azurewebsites.net/api/lighting',
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': '95dc73cb-4309-4576-9020-968f6aa88d48',
  },
});

// Tüm mekan parlaklıklarını alır
export const getBrightness = async (): Promise<Record<string, string>> => {
  const res = await api.get('/lobi');
  const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
  const { niagaraStatus, ...lighting } = data;
  return lighting;
};

// Tek bir mekanın parlaklığını günceller
export const setBrightness = async (key: string, value: number): Promise<void> => {
  await api.post('/lobi', { [key]: value.toString() });
};
